var controls = [].concat(
    require('./forms'),
    require('./html'),
    require('./user')
);

var t = controls.reduce(function(r, o){
    Object.keys(o).forEach(function (k) {
        r[k] = o[k];
    });
    return r;
}, {});

module.exports = t;